import { pxArrayToRem, pxToRem, type StyleRule } from '@archipro-design/aria';

export const BannerContainer: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.colors.white['200A'],
    padding: pxArrayToRem([10, 30]),
    margin: pxArrayToRem([19, 22, 8, 17]),
    lineHeight: pxToRem(24),
    fontSize: pxToRem(14),
    textAlign: 'center',
    '& u': {
        cursor: 'pointer',
    },
    [theme.screen.tablet]: {
        fontSize: pxToRem(18),
        padding: pxArrayToRem([22, 0]),
        margin: pxArrayToRem([0, 0, 39, 0]),
    },
});
